<template>
  <div id="page-voucher-list">
    <vx-title-bar :route="$route" :isRTL="$vs.rtl" />
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <dx-data-grid
          class="dx-card wide-card"
          :data-source="customDataSource"
          :show-borders="false"
          :column-auto-width="true"
          :column-hiding-enabled="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :ref="gridRefKey"
          @init-new-row="onInitNewRow"
          @editing-start="onEditingStart"
        >
          >
          <dx-state-storing
            :enabled="true"
            type="custom"
            :custom-load="loadState"
            :custom-save="saveState"
            :storage-key="storageKey"
          />
          <!-- <dx-master-detail :enabled="true" template="master-detail" />
          <template #master-detail="{ data }">
            <voucher-usage-list :master-detail-data="data" />
          </template> -->
          <dx-editing
            :allow-adding="true"
            :allow-updating="true"
            :use-icons="true"
            :allow-deleting="true"
            mode="popup"
          >
            <dx-grid-popup
              :show-title="true"
              :width="600"
              height="auto"
              :title="editTitle"
            >
              <dx-position my="center" at="center" of="window" />
            </dx-grid-popup>
            <dx-form>
              <dx-item
                :col-count="1"
                :col-span="2"
                item-type="group"
              >
                <dx-item data-field="code" />
                <dx-item data-field="isOneOff" />
                <dx-item data-field="value" />
                <dx-item data-field="minimumSpentAmount" />
                <dx-item data-field="validFrom" />
                <dx-item data-field="validUntil" />
                <dx-item :col-count="2" :col-span="2" item-type="group">
                  <dx-item data-field="description" :col-span="2" />
                </dx-item>
              </dx-item>
            </dx-form>
          </dx-editing>
          <dx-paging :page-size="20" />
          <dx-pager :show-page-size-selector="false" :show-info="true" />
          <dx-filter-row :visible="true" />
          <dx-column
            data-field="id"
            caption="Id"
            data-type="number"
            :width="90"
            :visible="false"
          />

          <dx-column
            data-field="code"
            :caption="$t('Voucher.Code')"
            :width="200"
          />
          <dx-column
            data-field="isOneOff"
            :caption="$t('Voucher.IsOneOff')"
            :width="200"
            data-type="boolean"
          />
          <dx-column
            data-field="value"
            :caption="$t('Voucher.Value')"
            :width="200"
            data-type="number"
            :format="{ type: 'currency', precision: 2, currency: 'EUR' }"
          />
          <dx-column
            data-field="minimumSpentAmount"
            :caption="$t('Voucher.MinimumSpentAmount')"
            :width="200"
            data-type="number"
            :format="{ type: 'currency', precision: 2, currency: 'EUR' }"
          />

          <dx-column
            data-field="description"
            :caption="$t('Voucher.Description')"
            :width="300"
          />
          <dx-column
            data-field="validFrom"
            :caption="$t('Voucher.ValidFrom')"
            :width="200"
            data-type="date"
            format="shortDate"
          />
          <dx-column
            data-field="validUntil"
            :caption="$t('Voucher.ValidUntil')"
            :width="200"
            data-type="date"
            format="shortDate"
          />
          <dx-column
            data-field="spentAmount"
            :caption="$t('Voucher.SpentAmount')"
            :width="200"
            data-type="number"
            :format="{ type: 'currency', precision: 2, currency: 'EUR' }"
          />
          <dx-column />
        </dx-data-grid>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moduleVoucherManagement from '@/store/voucher-management/moduleVoucherManagement.js'
import CustomStore from 'devextreme/data/custom_store'
import { notifyMixin } from '@/mixins/notifyMixin'
import { DxItem } from 'devextreme-vue/form'
// import VoucherUserList from './VoucherUserList.vue'
import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxPager,
  DxPaging,
  DxStateStoring,
  // DxMasterDetail,
  DxEditing,
  DxPosition,
  DxForm,
  DxPopup as DxGridPopup
} from 'devextreme-vue/data-grid'

const gridRefKey = "grid-vouchers"
let _this = {}
export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxFilterRow,
    DxPager,
    DxPaging,
    DxStateStoring,
    // DxMasterDetail,
    DxEditing,
    DxPosition,
    DxForm,
    DxItem,
    DxGridPopup
    // VoucherUserList
  },
  mixins: [notifyMixin],
  data () {
    const customDataSource = new CustomStore({
      key: 'id',
      load: () => {
        return this.$store.dispatch('voucherManagement/fetchVouchers', _this.activeOrganisation.id)
          .then((res) => {
            return res.data.items
          })
          .catch((error) => {
            this.notifyError(error)
          })
      },
      insert: ( values) => {
        this.refreshDefaultVoucher()
        return this.$store
          .dispatch('voucherManagement/addVoucher', values)
          .then(() => {
            this.notifySuccess(this.$t('RecordAdded'))
          })
          .catch((error) => {
            this.notifyError(error)
          })
      },
      update: (key, values) => {
        return this.$store
          .dispatch('voucherManagement/saveVoucher', {
            id: key,
            ...values
          })
          .then(() => {
            this.notifySuccess(this.$t('RecordUpdated'))
          })
          .catch((error) => {
            this.notifyError(error)
          })
      },
      remove: (key) => {
        return this.$store
          .dispatch('voucherManagement/removeRecord', key)
          .then(() => {
            this.notifySuccess(this.$t('RecordDeleted'))
          })
          .catch((error) => {
            this.notifyError(error)
          })
      }
    })

    return {
      customDataSource,
      gridRefKey,
      storageKey: 'dx_datagrid_gridVoucher_2',
      restoreFullGridState: false,
      defaultVoucher: null,
      editTitle : ""
    }
  },
  watch: {
    activeOrganisation: function () {
      this.refreshGrid()
    },

  },
  computed: {
    ...mapGetters(["activeOrganisation"])
  },
  methods: {
    refreshGrid () {
      console.log(`refreshing grid ${this.$refs[gridRefKey]}`)
      const grid = this.$refs[gridRefKey].instance
      grid.refresh()
    },
    refreshDefaultVoucher () {
      this.$store
        .dispatch('voucherManagement/fetchVoucher').then((result) => {
          this.defaultVoucher = result.data.voucher
          this.defaultVoucher.idOrganisation = this.activeOrganisation.id
          console.log("defaultVoucher", this.defaultVoucher)
        })
    },
    loadState () {
      const storage = localStorage[this.storageKey]
      if (storage) {
        const state = JSON.parse(storage)
        if (this.restoreFullGridState) {
          return state
        } else {
          const res = {
            columns: state.columns,
            pageSize: state.pageSize
          }
          for (let i = 0; i < res.columns.length; i++) {
            delete res.columns[i].filterValue
          }
          return res
        }
      }
    },
    saveState (state) {
      localStorage[this.storageKey] = JSON.stringify(state)
    },
    onInitNewRow (e) {
      Object.assign(e.data, this.defaultVoucher)
      this.editTitle = this.$t("Voucher.New")
    },
    onEditingStart(e) {
      this.editTitle = this.$t("Voucher.Edit")
    }
  },
  mounted () {
  },
  created () {
    _this = this
    this.restoreFullGridState = this.$route.query.initial !== "true"
    if (!moduleVoucherManagement.isRegistered) {
      this.$store.registerModule(
        'voucherManagement',
        moduleVoucherManagement
      )
      moduleVoucherManagement.isRegistered = true
    }
    this.refreshDefaultVoucher()

  }
}
</script>

